<template>
<!--<div :id="uid" :style="{height: `${height}px`, width: `${width}px`, top: `${y}%`, left: `${x}%`, 'z-index': z, 'margin-left': `${offsetX}px`, 'margin-top': `${offsetY}px`}" class="field-card">-->
<div :id="uid" :style="{height: `${height}px`, width: `${width}px`, top: position.top, left: position.left, 'z-index': dragOffset ? 5000 : z, 'margin-left': position.mLeft, 'margin-top': `${offsetY}px`}" class="field-card" @mouseenter="OnMouseEnter" @mouseleave="OnMouseLeave">
    <div ref="imgContainer" class="img-container">
        <!--<img v-show="!hidden" :class="`${flipped ? 'flipped' : ''}`" style="width: 100%; height: 100%; position: absolute;" :src="require(`@/assets/previews/${img}.png`)">-->
        <img v-show="false" style="width: 0px; height: 0px; position: absolute; left: -1000px; top: -1000px" :src="`http://mylassets.mattkingz.cl/${img}.jpg`">
        <img v-show="!hidden" :class="`${flipped ? 'flipped' : ''}`" style="width: 100%; height: 100%; position: absolute;" :src="`http://mylassets.mattkingz.cl/previews/${img}.jpg`">
        <img v-show="hidden" :class="`${flipped ? 'flipped' : ''}`" style="width: 100%; height: 100%; position: absolute;" :src="require(`@/assets/previews/BACK-001.png`)">
        <!--<div style="position: absolute">{{this.x}}</div>-->
    </div>
</div>
</template>

<script>
import interact from 'interactjs'
export default {
    props: {
        uid: {type: String, default: ''},
        height: {type: Number, default: 0},
        width: {type: Number, default: 0},
        img: {type: String, default: 'ESP-001'}
    },
    data() {
        return {
            //uid: Math.random().toString().substring(2),
            x: 0,
            y: 0,
            z: 0,
            offsetX: 0,
            offsetY: 0,
            dragOffset: null,
            parent: null,
            childs: [],
            hidden: false,
            arena: null,
        }
    },
    mounted() {
        this.arena = this.$parent;
        let t = this;
        interact(this.$el).draggable({
            listeners: {
                start(e) {
                    t.OnStartDrag(e);
                },
                move(e) {
                    t.OnDrag(e);
                },
                end(e) {
                    t.OnEndDrag(e);
                }
            }
        }).dropzone({
            ondrop: function (e) {
                t.OnDrop(e);
            },
            ondragenter: function(e) {
                t.OnDragEnter(e);
            },
            ondragleave: function(e) {
                t.OnDragLeave(e);
            },
            ondropmove: function(e) {
                t.OnDragEnter(e);
            },
        })
    },
    methods: {
        OnStartDrag(e)
        {
            let rect = this.$el.getBoundingClientRect();
            this.dragOffset = {x: e.client.x - rect.x, y: e.client.y - rect.y};
            this.$refs.imgContainer.classList.add('card-dragged');
            this.$el.classList.add('no-transition');
        },
        OnDrag(e) {
            let rectArena = document.getElementById('arena').getBoundingClientRect();

            let x = ((e.client.x - rectArena.x - this.dragOffset.x) / rectArena.width) * 100;
            let y = ((e.client.y - rectArena.y - this.dragOffset.y) / rectArena.height) * 100;

            if(x < 0) x = 0;
            if(x > 95) x = 95;
            if(y < -5) y = -5;
            if(y > 95) y = 95;

            this.Move(x, y);

            if(this.parent && this.parent.DeattachCard)
            {
                this.$socket.client.emit('DeattachCard', {parent: this.parent.uid, card: this.uid});
                this.parent.DeattachCard(this);
            }

            this.$socket.client.emit('MoveCard', {id: this.uid, x: x, y: y});
        },
        OnEndDrag(e) {
            //console.log(e);
            this.dragOffset = null;
            this.$nextTick(() => {
                //this.hidden = this.parent ? this.parent.hidden : false;
                if(!this.parent)
                {
                    this.hidden = false;
                    this.$socket.client.emit('HideCard', {id: this.uid, hidden: false});
                }
                this.$emit('PreviewCard', null);
            });
            this.$refs.imgContainer.classList.remove('card-dragged');
            //this.$el.classList.remove('no-transition');
        },
        OnDrop(e) {
            let card = e.relatedTarget;
            if(card && card.__vue__)
            {
                if(this.parent && this.parent.OnDrop)
                    return this.parent.OnDrop(e);
                this.AttachCard(card.__vue__);
                this.$socket.client.emit('AttachCard', {parent: this.uid, card: card.__vue__.uid});
            }
            this.DragOver(card, false);
        },
        OnMouseEnter() {
            if(this.hidden) return;
            this.$emit('PreviewCard', this.img);
        },
        OnMouseLeave() {
            this.$emit('PreviewCard', null);
        },
        OnDragEnter(e) {
            //console.log(e);
            if(this.parent && this.parent.DragOver)
                return this.parent.DragOver(e.relatedTarget, true);
            this.DragOver(e.relatedTarget, true);
        },
        OnDragLeave(e) {
            console.log(e);
            if(this.parent && this.parent.DragOver)
                return this.parent.DragOver(e.relatedTarget, false);
            this.DragOver(e.relatedTarget, false);
        },
        Move(x, y, offsetX, offsetY, mirrored) {
            offsetX = offsetX ? offsetX : 0;
            offsetY = offsetY ? offsetY : 0;
            
            let rectArena = document.getElementById('arena').getBoundingClientRect();
            let W = rectArena.width;
            let cardWidthPercentage = this.width * 100 / W;
            let cardHeightPercentage = this.height * 100 / rectArena.height;
            this.x = mirrored ? 100-x-cardWidthPercentage : x;
            let z = parseInt((W * (x/100)) + this.width + offsetX);
            z = parseInt((z / W) * 1000);
            this.z = z;
            this.y = mirrored ? 100-y-cardHeightPercentage : y;
            this.offsetX = offsetX;
            this.offsetY = offsetY;

            for(let i = 0; i < this.childs.length; i++)
            {
                this.childs[i].Move(x, y, -(this.width*0.2) * (i+1), null, mirrored);
            }

        },
        AttachCard(card)
        {
            //console.log(this.img);
            /*
            if(this.parent && this.parent.AttachCard)
            {
                return this.parent.AttachCard(card);
            }
            */
            if(card.childs.length) return;
            //let parentTarget = this.parent ? this.parent : this;
            this.childs.push(card);
            card.SetParent(this);
            card.hidden = this.hidden;
            this.Move(this.x, this.y);
        },
        SetParent(card) 
        {
            this.parent = card;
        },
        DeattachCard(card) 
        {
            for(let i = 0; i < this.childs.length; i++)
            {
                if(this.childs[i].uid == card.uid)
                {
                    this.childs[i].parent = null;
                    this.childs.splice(i, 1);
                    this.Move(this.x, this.y);
                    break;
                }
            }
        },
        DragOver(card, entered)
        {
            if(card.__vue__ == this) return;
            if(entered) this.$el.classList.add('targeted');
            else this.$el.classList.remove('targeted');
        }
    },
    computed: {
        position() {
            if(!this.arena) return {};
            let rect = this.arena.$el.getBoundingClientRect();
            return {
                left: this.x+'%',
                top: this.y+'%',
                mLeft: this.offsetX+'px',
            }
            /*
            return {
                left: this.y >= 50 ? (rect.width * this.x / 100)+'px' : 'auto',
                right: this.y < 50 ? ((100 - this.x) * rect.width / 100)-this.width+'px' : 'auto',
                top: this.y+'%',
                mLeft: this.y >= 50 ? this.offsetX+'px' : 'auto',
                mRight: this.y < 50 ? -this.offsetX+'px' : 'auto'
            }
            */
        },
        flipped() {
            return this.parent && this.parent.private;
        }
    }
}
</script>

<style>
.field-card {
    position: absolute;
    transition: all 0.15s linear;
}
.field-card img {
    border-radius: 0.3vw;
}
.flipped {
    transform: scale(-1);
}
.targeted {
    outline: 3px dashed red;
}
.img-container {
    transition: all 0.1s linear;
    position: relative; width: 100%; height: 100%; pointer-events: none;
}
.card-dragged {
    transform: scale(1.3) rotate(-5deg);
    box-shadow: 10px 10px 10px rgba(0,0,0,0.3);
}
.no-transition {
    transition: none !important;
}
</style>